import { render, staticRenderFns } from "./InfoTextAreaInput.vue?vue&type=template&id=51b6b12a&scoped=true&"
import script from "./InfoTextAreaInput.vue?vue&type=script&lang=js&"
export * from "./InfoTextAreaInput.vue?vue&type=script&lang=js&"
import style0 from "../../../Style/info-text-area-input.scss?vue&type=style&index=0&id=51b6b12a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b6b12a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51b6b12a')) {
      api.createRecord('51b6b12a', component.options)
    } else {
      api.reload('51b6b12a', component.options)
    }
    module.hot.accept("./InfoTextAreaInput.vue?vue&type=template&id=51b6b12a&scoped=true&", function () {
      api.rerender('51b6b12a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/DmVisualizer/Components/ChangeInfo/Components/InfoTextAreaInput.vue"
export default component.exports